import { Clickable, H3, PortableText, SpacerWrapper } from '@ahmdigital/ui';
import { get } from 'lodash/fp';

import styles from './styles.module.sass';

type SummaryDescriptionProps = {
  callToAction?: {
    link?: string;
    linkText?: string;
  };
  mediaObject: {
    description?: string;
  };
  slogan: unknown[];
};

const SummaryDescription = ({ callToAction, mediaObject, slogan }: SummaryDescriptionProps) => {
  const description = get('description', mediaObject);

  return (
    <SpacerWrapper variant={[styles.wrapper]}>
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <div className={[styles.widthWrapper]}>
        {slogan && (
          <H3 looksLike="h4" variant="marginBottomSpacer10">
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
            <PortableText source={slogan} />
          </H3>
        )}
        {description && (
          <SpacerWrapper variant={styles.body}>
            <PortableText source={description} />
          </SpacerWrapper>
        )}
        {callToAction && (
          <Clickable to={get('link', callToAction)} variant="marginTopSpacer10">
            {get('linkText', callToAction)}
          </Clickable>
        )}
      </div>
    </SpacerWrapper>
  );
};

export default SummaryDescription;
